import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import BSRequests from "./BSRequests";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";
import {ChevronRight} from "lucide-react";
import {Button} from "@mui/material";
import {Link} from "react-router-dom";


function BSRequestsPage(){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('bsRequests')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title mb-0">{t('bsRequests')}</Title>
                    <BSRequests/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(BSRequestsPage);
